// extracted by mini-css-extract-plugin
export default {"section":"zYscvP","accessibilityTheme":"iXkVIL","button":"fwH_JV"};